import styles from "./BetterHelpCTA.module.css";

import { Mixpanel } from "@/helpers/mixpanel";
import { useModalContext } from "@/context/ModalContext";
import { GeneralModalArrayParagraph } from "@/components/shared/GeneralModal/GeneralModal";
import { openInNewTab } from "@/components/shared/utils";
import ThemedButton from "@/components/shared/ThemedButton/ThemedButton";
import { useAuth } from "@/context/AuthContext";

export default function BetterHelpCTA() {
  const { setModalComponent } = useModalContext();

  const { user } = useAuth();

  return (
    <section className={styles.main}>
      <p className={styles.sponsoredText}>SPONSORED</p>
      <div className={styles.iconDiv}>
        <BetterHelpIcons />
      </div>
      <h2 className={styles.title}>BetterHelp makes starting therapy easy</h2>
      <ul className={styles.ul}>
        <li className={styles.li}>
          Up to 50% more affordable than traditional in-person therapy
        </li>
        <li className={styles.li}>
          Dimensional users get 20% off their first month.{" "}
        </li>
      </ul>
      <ThemedButton
        style={{ width: "fit-content", marginTop: "27px", alignSelf: "center" }}
        title="Get Started - 20% off"
        onClick={() => {
          Mixpanel?.track(
            "BetterHelp | Get started CTA pressed",
            {},
            user?.uid
          );
          if (window.Android) {
            window.Android.openInNewTab(
              "https://hasofferstracking.betterhelp.com/aff_c?offer_id=40&aff_id=4356&source=dimensional20"
            );
          } else {
            openInNewTab(
              "https://hasofferstracking.betterhelp.com/aff_c?offer_id=40&aff_id=4356&source=dimensional20"
            );
          }
        }}
      />
      <p
        onClick={() => {
          Mixpanel?.track(
            "BetterHelp | Partnership details CTA pressed",
            {},
            user?.uid
          );
          setModalComponent(
            <GeneralModalArrayParagraph
              title="Partnership details"
              body={[
                "Partnerships help support the continued development of Dimensional. We are partnering with BetterHelp because they provide accessible, licensed therapy to millions of people, many of whom might not otherwise seek support.",
                "We chose to work with BetterHelp because of their recent investments in strong privacy protections, compliance with FTC regulations, and safeguards to ensure ethical practices. Today, BetterHelp remains one of the largest and most trusted online therapy platforms, offering a valuable service to those in need. If you’re considering therapy, BetterHelp can be a great option—but as always, finding the right provider for your needs is most important.",
                "We do not sell or transfer any of your data to BetterHelp.",
              ]}
            />
          );
        }}
        className={styles.partnershipText}
      >
        As a BetterHelp affiliate, we receive compensation if you purchase
        products or services through the links provided. Learn more.
      </p>
    </section>
  );
}

function BetterHelpIcons() {
  return (
    <svg
      width="172"
      height="29"
      viewBox="0 0 172 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="25.3779"
        y="4"
        width="6.12499"
        height="20.9999"
        rx="3.06249"
        fill="#FFFFF2"
      />
      <rect
        x="32.7852"
        y="4"
        width="6.12497"
        height="21"
        rx="3.06248"
        fill="#FFFFF2"
      />
      <rect
        x="40.2393"
        y="4"
        width="6.12498"
        height="21"
        rx="3.06249"
        fill="#FFFFF2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.0849 25.0001C16.8839 25.0001 21.5849 20.2991 21.5849 14.5001C21.5849 8.70112 16.8839 4.00012 11.0849 4.00012C5.28596 4.00012 0.584961 8.70112 0.584961 14.5001C0.584961 20.2991 5.28596 25.0001 11.0849 25.0001ZM11.0501 16.2014C12.0094 16.2014 12.787 15.4238 12.787 14.4644C12.787 13.5051 12.0094 12.7274 11.0501 12.7274C10.0907 12.7274 9.31306 13.5051 9.31306 14.4644C9.31306 15.4238 10.0907 16.2014 11.0501 16.2014Z"
        fill="#FFFFF2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M69.5235 24.5048C71.6454 24.5048 72.9627 22.1973 71.8841 20.3698L63.3178 5.85608C62.257 4.05888 59.6573 4.05888 58.5965 5.85609L50.0303 20.3698C48.9516 22.1973 50.2689 24.5048 52.3909 24.5048H69.5235ZM60.9759 18.2139C61.9599 18.2139 62.7577 17.4161 62.7577 16.432C62.7577 15.4478 61.9599 14.65 60.9759 14.65C59.9918 14.65 59.1941 15.4478 59.1941 16.432C59.1941 17.4161 59.9918 18.2139 60.9759 18.2139Z"
        fill="#FFFFF2"
      />
      <path
        d="M92.7691 3.77002C92.1279 3.77002 91.6091 4.28886 91.6091 4.93002V13.34H83.1991C82.5579 13.34 82.0391 13.8589 82.0391 14.5C82.0391 15.1412 82.5579 15.66 83.1991 15.66H91.6091V24.07C91.6091 24.7112 92.1279 25.23 92.7691 25.23C93.4102 25.23 93.9291 24.7112 93.9291 24.07V15.66H102.339C102.98 15.66 103.499 15.1412 103.499 14.5C103.499 13.8589 102.98 13.34 102.339 13.34H93.9291V4.93002C93.9291 4.28886 93.4102 3.77002 92.7691 3.77002Z"
        fill="#FFFFF2"
      />
      <g clip-path="url(#clip0_67926_13487)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M168.299 7.70927C168.299 7.70927 158.465 1.30802 149.832 4.15228C146.937 5.10456 144.548 6.97471 142.649 9.04008C141.581 10.2015 140.351 12.8532 136.655 14.2958C135.842 14.6128 134.93 14.9444 133.781 15.0873C132.11 15.2951 131.015 15.6994 129.618 16.0588C129.033 16.2083 127.886 16.5465 127.806 15.8093C127.751 15.3189 128.269 15.1846 128.714 15.0549C129.661 14.7776 130.338 14.54 131.264 14.2171C131.587 14.1039 132.433 13.9656 132.331 13.6255C132.262 13.3938 131.708 13.5341 131.445 13.5864C129.806 13.9067 128.316 14.1913 126.657 14.45C125.988 14.5559 125.175 14.6796 125.059 14.0887C124.887 13.2125 125.982 13.1927 126.737 13.0603C128.131 12.8174 129.233 12.5739 130.573 12.3085C130.785 12.2669 131.079 12.2596 131.169 12.022C130.929 11.8579 130.576 11.9631 130.282 12.0074C128.48 12.2702 126.584 12.5527 124.834 12.9167C124.252 13.0371 123.656 13.0888 123.532 12.5587C123.319 11.6594 124.477 11.5138 125.221 11.3324C126.807 10.946 128.137 10.8202 129.914 10.5231C130.158 10.4807 130.706 10.4252 130.704 10.2213C130.706 9.9381 129.849 10.0268 129.561 10.0268C128.266 10.0261 127.318 10.1274 125.888 10.273C125.108 10.3517 124.115 10.6045 124.02 9.90303C123.873 8.81376 126.019 8.92361 126.948 8.81707C128.718 8.6106 130.399 8.54707 132.018 8.13016C132.762 7.93891 133.755 7.69207 133.823 7.16795C133.891 6.62993 133.149 6.03038 132.901 5.8689C132.501 5.61148 132.002 5.42817 131.596 5.11714C131.197 4.80809 130.778 4.44677 130.568 4.04706C130.337 3.6103 130.258 2.59846 130.91 2.56405C131.17 2.55015 131.763 3.05706 131.96 3.18743C132.337 3.43361 132.678 3.61361 132.987 3.8353C133.561 4.24758 133.941 4.71346 134.514 4.99471C134.943 5.20449 135.369 5.35934 135.783 5.57707C136.185 5.79015 136.59 5.99927 136.983 6.23883C137.394 6.49096 137.773 7.06471 138.317 7.35391C141.332 8.94744 142.923 5.96221 142.193 5.5817C138.423 3.61295 132.222 1.02743 128.555 1.40199C119.517 2.32316 113.108 12.1861 113.108 12.1861C113.108 12.1861 121.354 20.5535 130.391 19.6323C135.046 19.1591 138.999 16.3135 141.741 13.6658C141.671 13.5805 144.3 10.4496 147.487 9.32133C149.075 8.75883 150.058 8.12817 151.349 7.47699C151.887 7.20435 152.936 6.62795 153.171 7.33008C153.328 7.79795 152.85 8.04016 152.445 8.26185C151.577 8.73633 150.966 9.1142 150.13 9.63038C149.841 9.80906 149.042 10.126 149.214 10.4371C149.33 10.6488 149.841 10.3927 150.089 10.2842C151.621 9.61979 153.017 9.02023 154.582 8.41141C155.212 8.16325 155.981 7.86876 156.22 8.42001C156.575 9.23994 155.51 9.49406 154.798 9.78589C153.489 10.3239 152.464 10.7977 151.212 11.3457C151.013 11.4324 150.728 11.5019 150.691 11.7533C150.96 11.8625 151.281 11.6838 151.561 11.5773C153.265 10.9321 155.056 10.2491 156.688 9.51656C157.231 9.27567 157.803 9.09633 158.037 9.58803C158.436 10.4192 157.336 10.8123 156.648 11.1485C155.181 11.8665 153.908 12.2755 152.235 12.9478C152.005 13.0418 151.483 13.2132 151.526 13.4124C151.585 13.6903 152.403 13.419 152.685 13.3568C153.95 13.0795 154.855 12.7757 156.22 12.3277C156.965 12.0816 157.884 11.6216 158.123 12.2854C158.499 13.3184 156.379 13.6731 155.494 13.9769C153.81 14.5585 152.181 14.9834 150.688 15.7378C150.002 16.0846 149.085 16.5392 149.131 17.066C149.177 17.606 150.029 18.0328 150.306 18.1367C150.752 18.3022 151.277 18.3736 151.74 18.5927C152.196 18.8064 152.683 19.0691 152.972 19.4146C153.291 19.7918 153.582 20.7633 152.952 20.9366C152.703 21.0061 152.015 20.6388 151.796 20.5541C151.374 20.3947 151.003 20.2921 150.654 20.1425C150.006 19.8633 149.536 19.4887 148.916 19.3378C148.453 19.2253 148.003 19.1651 147.552 19.0413C147.115 18.9202 146.675 18.8031 146.24 18.6536C145.785 18.4954 145.19 18.2241 144.7 17.8515C144.53 17.7231 144.203 17.4822 143.836 17.5888C141.405 17.6457 139.013 18.9838 137.657 21.3363C136.334 23.6327 136.329 26.3102 137.405 28.4358C137.179 26.8323 137.475 25.115 138.364 23.5738C139.209 22.1066 140.458 21.0313 141.867 20.4145C145.514 21.8644 150.689 23.1522 155.502 21.566C164.134 18.7217 168.299 7.70927 168.299 7.70927Z"
          fill="#FFFFF2"
        />
      </g>
      <defs>
        <clipPath id="clip0_67926_13487">
          <rect
            width="57.875"
            height="27.8245"
            fill="white"
            transform="translate(113.27 0.587769)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
